export const MockData: { [key: string]: Mock } = {
  // example mock
  // 'app_rspmbridge.get_campaign_status': {
  //   response: (params: any) => {
  //     return {
  //       cmd: {
  //         params: {
  //           campaignId: '123',
  //           campaignStatus: 'VALIDATE_FAILED',
  //           completedMembers: 0,
  //           failedCreateMembers: 1,
  //           failedMembers: 0,
  //           inProgressMembers: 0,
  //           newMemberEntities: 0,
  //         },
  //         success: true,
  //       },
  //     };
  //   },
  // },
};

export const MockedEndpoint = {
  // example mock endpoint
  // "https://toes-engr.devicewise.net/private/campaigns/upload" : (...args) => {
  //     console.log('ex')
  //     return { status: 'ERROR', errorMessage: 'PERMISSION DENY'}},
};

interface Mock {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: (...args: any[]) => unknown;
}
